import styled from "@emotion/styled";
import { Switch } from "@mui/material";

const DarkLightSwitch = styled(Switch)(({ theme }) => ({
  // padding: 0,
  // width: 65,
  // "& > span.MuiButtonBase-root": {
  //   padding: "4px 6px",
  //   left: 0,
  //   "&.Mui-checked": {
  //     left: 8,
  //   },
  // },
  "& .MuiSwitch-track": {
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      top: "41%",
      transform: "translateY(-50%)",
    },
    "&:before": {
      backgroundImage: "url('/static/images/moon.png')",
      backgroundRepeat: "no-repeat",
      right: 0,
      top: "40%",
      width: 22,
      height: 22,
    },
    "&:after": {
      backgroundImage: "url('/static/images/sun.png')",
      backgroundRepeat: "no-repeat",
      left: 4,
      top: "40%",
      width: 20,
      height: 20,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 22,
    height: 22,
  },
}));

export default DarkLightSwitch;
